export const MAP_ZOOM_PICKER_ZOOM_LEVELS = [11, 7, 4] as const;
export const MAP_USER_INTERACTION_KEYS = {
    presetZoom: 'Preset_Zoom',
    scrollWheelZoom: 'Scroll_Wheel_Zoom',
    doubleClickZoom: 'Double_Click_Zoom',
    plusButtonClickZoomIn: 'Plus_Button_Click_Zoom_In',
    minusButtonClickZoomOut: 'Plus_Button_Click_Zoom_Out',
    layersButtonOpenWeatherLayersMenu: 'Layers_Button_Open_Weather_Layers_Menu',
    layersButtonCloseWeatherLayersMenu: 'Layers_Button_Close_Weather_Layers_Menu',
    playAnimation: 'Play_Animation',
    pauseAnimation: 'Pause_Animation',
    cycleSevenSlotsAnimation: 'Cycle_Seven_Slots_Animation',
    infoButtonHideLegend: 'Info_Button_Hide_Legend',
    infoButtonShowLegend: 'Info_Button_Show_Legend',
    closeWeatherLayersMenuCloseIcon: 'Close_Weather_Layers_Menu_Close_Icon',
    mapsTabInactiveToActive: 'Maps_Tab_Inactive_To_Active',
    mouseGrabPan: 'Mouse_Grab_Pan',
    clickPanToMarkerButton: 'Click_Pan_To_Marker_Button',
    onOpacitySliderChangeComplete: 'On_Opacity_Slider_Change_Complete'
} as const;

export const CONDITION_DETAIL_URL = '/weather-forecast/now/';
export const VERBOSE = false;
export const REFRESH = false;
export const DEFAULT_OBS_INTERVAL = 5 * 60 * 1000;
